import { useLojinhaContext } from '@lojinha/context'
import { GetKitQuery, GetKitQueryVariables, useQuery } from '@lojinha/palantir'
import { useRouter } from 'next/router'
import { KIT_QUERY } from './queries'

export const useKit = () => {
  const router = useRouter()
  const { slug } = router.query

  const { centerId: distributionCenterId } = useLojinhaContext()

  const { data, loading } = useQuery<GetKitQuery, GetKitQueryVariables>(
    KIT_QUERY,
    {
      variables: {
        slug: `${slug}/k`,
        distributionCenterId,
      },
    }
  )

  return {
    data,
    loading,
  }
}
